module.exports = __webpack_public_path__ + "a3edc4148e425d91dfb38e4eddf71bd6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/eagles-nest-empty.png
// module id = 305
// module chunks = 0